import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import I18n from 'I18n';
import styled from 'styled-components';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UISelect from 'UIComponents/input/UISelect';
import H5 from 'UIComponents/elements/headings/H5';
import { ADS_GOAL_TYPES } from 'goals-reporting-lib/constants/ads';
import UIMicroDateRange from 'UIComponents/dates/UIMicroDateRange';
import UIInlineLabel from 'UIComponents/form/UIInlineLabel'; // @ts-expect-error cannot find declaration file

import AdAccountSelect from 'AdsUI/components/AdAccountSelect';
import GoalStatusFilter from 'AdsUI/components/goals/GoalStatusFilter';
import GoalDurationFilter from 'AdsUI/components/goals/GoalDurationFilter';
import GoalProgressFilter from 'AdsUI/components/goals/GoalProgressFilter';
import { useSelector } from 'react-redux'; // @ts-expect-error cannot find declaration file

import { hasTemplateGoals } from 'AdsUI/selectors/AuthSelectors';
const GoalTypeSelect = styled.div.withConfig({
  displayName: "GoalsFilters__GoalTypeSelect",
  componentId: "grep2s-0"
})(["min-width:360px;margin-right:40px;"]);
const FilterContainer = styled.div.withConfig({
  displayName: "GoalsFilters__FilterContainer",
  componentId: "grep2s-1"
})(["line-height:2.5em;vertical-align:baseline;flex-wrap:wrap;display:flex;justify-content:start;align-items:center;"]);

const getGoalTypeOptions = hasTemplateGoalsAccess => {
  return ADS_GOAL_TYPES.map(goalType => ({
    value: goalType,
    text: hasTemplateGoalsAccess ? I18n.text(`goals-reporting-lib.goalTypes.templates.options.${goalType}`) : I18n.text(`goals-reporting-lib.goalTypes.options.${goalType}`)
  })).sort((a, b) => a.text.localeCompare(b.text));
};

const GoalsFilters = ({
  handleUpdateGoalTypeFilter,
  handleUpdateDateFilter,
  handleUpdateAdAccountFilter,
  handleUpdateDurationFilter,
  handleUpdateStatusFilter,
  handleUpdateProgressFilter,
  selectedGoalType,
  selectedDateRange,
  selectedAdAccounts,
  connectedUsers,
  adAccounts,
  selectedDurations,
  selectedStatuses,
  selectedProgress
}) => {
  const hasTemplateGoalsAccess = useSelector(hasTemplateGoals);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(FilterContainer, {
      className: "m-bottom-3",
      children: [/*#__PURE__*/_jsx(UIInlineLabel, {
        label: /*#__PURE__*/_jsx(H5, {
          className: "p-top-3 m-right-2",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: hasTemplateGoalsAccess ? 'goalsDashboard.templateNameFilter' : 'goalsDashboard.goalTypeFilter'
          })
        }),
        children: /*#__PURE__*/_jsx(GoalTypeSelect, {
          children: /*#__PURE__*/_jsx(UISelect, {
            "data-test-id": "goal-type-select",
            buttonUse: "form-on-dark",
            value: selectedGoalType,
            menuWidth: 360,
            options: getGoalTypeOptions(hasTemplateGoalsAccess),
            onChange: handleUpdateGoalTypeFilter
          })
        })
      }), /*#__PURE__*/_jsx(UIInlineLabel, {
        label: /*#__PURE__*/_jsx(FormattedMessage, {
          className: "m-right-2",
          message: "goalsDashboard.endDateFilter.label"
        }),
        children: /*#__PURE__*/_jsx(UIMicroDateRange, {
          tz: "utc",
          "aria-label": I18n.text('goalsDashboard.endDateFilter.ariaLabel'),
          value: selectedDateRange,
          onChange: handleUpdateDateFilter
        })
      })]
    }), /*#__PURE__*/_jsxs(FilterContainer, {
      className: "m-bottom-4",
      children: [/*#__PURE__*/_jsx(AdAccountSelect, {
        adAccounts: adAccounts,
        connectedUsers: connectedUsers,
        accountFilter: selectedAdAccounts,
        onFilterChange: handleUpdateAdAccountFilter
      }), /*#__PURE__*/_jsx(GoalDurationFilter, {
        selectedDurations: selectedDurations,
        onChangeDurations: handleUpdateDurationFilter
      }), /*#__PURE__*/_jsx(GoalStatusFilter, {
        selectedStatuses: selectedStatuses,
        onChangeStatuses: handleUpdateStatusFilter
      }), /*#__PURE__*/_jsx(GoalProgressFilter, {
        minProgress: selectedProgress.minPercentage,
        maxProgress: selectedProgress.maxPercentage,
        onChangeProgress: handleUpdateProgressFilter
      })]
    })]
  });
};

export default GoalsFilters;